module.exports = {
    handle: (e, data) => {
        if (data.gtmData) {
            const {
                gtmData: {
                    products,
                    actionField,
                }
            } = data;

            const newProducts = [];

            products.forEach((element) => {
                newProducts.push({
                    'item_name' : element.name,
                    'item_id' : element.id,
                    'price' : element.price,
                    'item_brand' : element.brand,
                    'item_category' : element.category,
                    'quantity' : element.quantity
                });
            });

            const { customerId, emailAddress } = actionField;

            const purchaseData = {
                event: 'purchase',
                currency: 'CLP',
                suscripcion: actionField.subscription ? 'Activa' : 'Inactiva',
                transaction_id: actionField.id,
                tax: actionField.tax,
                shipping: actionField.shipping,
                value: actionField.revenue - actionField.shipping - actionField.tax,
                items: newProducts
            };

            customerId ? purchaseData.userId = customerId : null;
            emailAddress ? purchaseData.email = emailAddress : null;

            dataLayer.push(purchaseData);
        }
    }
}